var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
import dayjs from 'dayjs';
import { MemberAllocationMutationTypes } from '@/types/member-allocation';
import { AttendanceDisplayStatus } from '@/types/attendance';
import { STATUS_MAP } from '@/pages/companies/_company_id/projects/_id/attendance/utils';
import MemberAllocationApiClient from '@/plugins/apis/v2/member-allocation-api-client';
var USER_LIMIT = 20;
var MEMBER_SCROLL_CHUNK = 50;
var MEMBER_SCROLL_STEP = 10;
var memberWindowCache = new Map();
var memberWindowInFlight = new Map();
var queuedWindowOffset = null;
var memberWindowCacheGeneration = 0;
var bypassMemberWindowCacheUntil = 0;
var CACHE_BYPASS_MS_AFTER_MUTATION = 5000;
var staleLoadedMonths = new Set();
function memberWindowCacheKey(options) {
    return options.companyId + "::" + options.month + "::" + options.startOffset + "::" + options.chunkSize;
}
function resetMemberWindowCache() {
    memberWindowCacheGeneration += 1;
    memberWindowCache.clear();
    memberWindowInFlight.clear();
    queuedWindowOffset = null;
    staleLoadedMonths.clear();
}
function normalizeWindowOffset(params) {
    var requestedOffset = params.requestedOffset, totalUsers = params.totalUsers;
    var snapped = Math.max(0, Math.floor(requestedOffset / MEMBER_SCROLL_STEP) * MEMBER_SCROLL_STEP);
    if (typeof totalUsers !== 'number')
        return snapped;
    var maxStart = Math.max(0, totalUsers - MEMBER_SCROLL_CHUNK);
    return Math.max(0, Math.min(snapped, maxStart));
}
function buildDayKeysFromRange(startDate, endDate) {
    var start = dayjs(startDate);
    var end = dayjs(endDate);
    var days = [];
    var cur = start;
    while (!cur.isAfter(end)) {
        days.push(cur.format('YYYY-MM-DD'));
        cur = cur.add(1, 'day');
    }
    return days;
}
function mergeUsersIntoMaps(currentMembers, currentTasks, users, dayKeysForMonth, options) {
    var allowAddMembers = (options === null || options === void 0 ? void 0 : options.allowAddMembers) !== false;
    var targetMemberIds = options === null || options === void 0 ? void 0 : options.targetMemberIds;
    var _loop_1 = function (user) {
        var userId = user.id || '';
        if (!userId)
            return "continue";
        if (targetMemberIds && !targetMemberIds.has(userId))
            return "continue";
        var member = {
            id: userId,
            name: user.name,
            role: user.role || user.user_type || 'member',
            avatar: user.avatar
        };
        if (allowAddMembers && !currentMembers.find(function (m) { return m.id === userId; })) {
            currentMembers.push(member);
        }
        if (!currentTasks[userId]) {
            currentTasks[userId] = {};
        }
        var row = currentTasks[userId];
        for (var _i = 0, dayKeysForMonth_1 = dayKeysForMonth; _i < dayKeysForMonth_1.length; _i++) {
            var d = dayKeysForMonth_1[_i];
            if (!row[d]) {
                row[d] = [];
            }
        }
        for (var _a = 0, _b = user.days; _a < _b.length; _a++) {
            var day = _b[_a];
            var tasks = [];
            for (var _c = 0, _d = day.projects; _c < _d.length; _c++) {
                var project = _d[_c];
                for (var _e = 0, _f = project.large_processes; _e < _f.length; _e++) {
                    var lp = _f[_e];
                    tasks.push({
                        id: lp.id,
                        projectId: project.id,
                        startTime: formatTimeProject(lp.start_time),
                        endTime: formatTimeProject(lp.end_time),
                        projectName: project.title,
                        processName: lp.name,
                        timeOverlap: lp.time_overlap,
                        statusLabel: stampStatusToLabel(lp.stamp_status)
                    });
                }
            }
            row[day.date] = tasks;
        }
    };
    for (var _i = 0, users_1 = users; _i < users_1.length; _i++) {
        var user = users_1[_i];
        _loop_1(user);
    }
}
function shallowCloneTasksByMember(src) {
    var out = {};
    for (var _i = 0, _a = Object.keys(src); _i < _a.length; _i++) {
        var uid = _a[_i];
        out[uid] = __assign({}, src[uid]);
    }
    return out;
}
/** Paginate one calendar month and merge into copies of members/tasks (does not touch Vuex). */
function fetchFullMonthForMerge(companyId, month, baseMembers, baseTasks) {
    return __awaiter(this, void 0, Promise, function () {
        var members, tasks, targetMemberIds, mergedTargetMemberIds, offset, mergedDays, first, res, data, days, _i, _a, user, userId, meta, next;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    members = __spreadArrays(baseMembers);
                    tasks = shallowCloneTasksByMember(baseTasks);
                    targetMemberIds = new Set(baseMembers.map(function (m) { return m.id; }).filter(Boolean));
                    mergedTargetMemberIds = new Set();
                    offset = 0;
                    mergedDays = [];
                    first = true;
                    _b.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            month: month,
                            user_offset: offset,
                            user_limit: USER_LIMIT
                        })];
                case 2:
                    res = _b.sent();
                    data = res.data;
                    days = buildDayKeysFromRange(data.start_date, data.end_date);
                    if (first) {
                        mergedDays = days;
                        first = false;
                    }
                    mergeUsersIntoMaps(members, tasks, data.users, days, {
                        allowAddMembers: false,
                        targetMemberIds: targetMemberIds
                    });
                    for (_i = 0, _a = data.users; _i < _a.length; _i++) {
                        user = _a[_i];
                        userId = user.id || '';
                        if (!userId)
                            continue;
                        if (targetMemberIds.has(userId)) {
                            mergedTargetMemberIds.add(userId);
                        }
                    }
                    // Horizontal month paging should only enrich currently loaded members.
                    if (mergedTargetMemberIds.size >= targetMemberIds.size)
                        return [3 /*break*/, 3];
                    meta = data.meta;
                    if (!meta || !meta.has_more_users)
                        return [3 /*break*/, 3];
                    next = meta.next_user_offset;
                    if (next == null)
                        return [3 /*break*/, 3];
                    offset = next;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, { mergedDays: mergedDays, members: members, tasks: tasks }];
            }
        });
    });
}
function stampStatusToLabel(status) {
    if (status === AttendanceDisplayStatus.MISSING_STAMP) {
        return STATUS_MAP[AttendanceDisplayStatus.MISSING_STAMP].getDisplayValue(0);
    }
    return null;
}
function fetchSingleUserTasksForMonth(options) {
    return __awaiter(this, void 0, Promise, function () {
        var companyId, month, userId, maxOffset, offset, tasksByDay, res, data, user, _i, _a, day, tasks, _b, _c, project, _d, _e, lp, meta;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    companyId = options.companyId, month = options.month, userId = options.userId, maxOffset = options.maxOffset;
                    offset = 0;
                    tasksByDay = {};
                    _f.label = 1;
                case 1:
                    if (!(offset <= maxOffset)) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            month: month,
                            user_offset: offset,
                            user_limit: USER_LIMIT
                        })];
                case 2:
                    res = _f.sent();
                    data = res.data;
                    user = (data.users || []).find(function (item) { return item.id === userId; });
                    if (user) {
                        for (_i = 0, _a = user.days || []; _i < _a.length; _i++) {
                            day = _a[_i];
                            tasks = [];
                            for (_b = 0, _c = day.projects || []; _b < _c.length; _b++) {
                                project = _c[_b];
                                for (_d = 0, _e = project.large_processes || []; _d < _e.length; _d++) {
                                    lp = _e[_d];
                                    tasks.push({
                                        id: lp.id,
                                        projectId: project.id,
                                        startTime: formatTimeProject(lp.start_time),
                                        endTime: formatTimeProject(lp.end_time),
                                        projectName: project.title,
                                        processName: lp.name,
                                        timeOverlap: lp.time_overlap,
                                        statusLabel: stampStatusToLabel(lp.stamp_status)
                                    });
                                }
                            }
                            tasksByDay[day.date] = tasks;
                        }
                        return [2 /*return*/, { tasksByDay: tasksByDay }];
                    }
                    meta = data.meta;
                    if (!meta || !meta.has_more_users || meta.next_user_offset == null) {
                        return [3 /*break*/, 3];
                    }
                    if (meta.next_user_offset <= offset) {
                        return [3 /*break*/, 3];
                    }
                    offset = meta.next_user_offset;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, { tasksByDay: null }];
            }
        });
    });
}
function fetchValidMemberWindow(options) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var companyId, month, startOffset, chunkSize, members, tasksByMemberAndDay, offset, nextOffset, hasMoreUsers, totalUsers, days, isFirstRequest, res, data, metaNextOffset;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    companyId = options.companyId, month = options.month, startOffset = options.startOffset, chunkSize = options.chunkSize;
                    members = [];
                    tasksByMemberAndDay = {};
                    offset = startOffset;
                    nextOffset = startOffset;
                    hasMoreUsers = true;
                    totalUsers = null;
                    days = [];
                    isFirstRequest = true;
                    _e.label = 1;
                case 1:
                    if (!(members.length < chunkSize && hasMoreUsers)) return [3 /*break*/, 3];
                    return [4 /*yield*/, MemberAllocationApiClient.fetchTimeline(companyId, {
                            month: month,
                            user_offset: offset,
                            user_limit: chunkSize
                        })];
                case 2:
                    res = _e.sent();
                    data = res.data;
                    if (isFirstRequest) {
                        days = buildDayKeysFromRange(data.start_date, data.end_date);
                        isFirstRequest = false;
                    }
                    if (typeof ((_a = data.meta) === null || _a === void 0 ? void 0 : _a.total_users) === 'number') {
                        totalUsers = data.meta.total_users;
                    }
                    mergeUsersIntoMaps(members, tasksByMemberAndDay, data.users || [], days);
                    if (members.length > chunkSize) {
                        members.splice(chunkSize);
                    }
                    metaNextOffset = (_b = data.meta) === null || _b === void 0 ? void 0 : _b.next_user_offset;
                    hasMoreUsers = !!((_c = data.meta) === null || _c === void 0 ? void 0 : _c.has_more_users) && metaNextOffset != null;
                    if (!hasMoreUsers || metaNextOffset == null || metaNextOffset <= offset) {
                        nextOffset = offset + (((_d = data.users) === null || _d === void 0 ? void 0 : _d.length) || 0);
                        return [3 /*break*/, 3];
                    }
                    nextOffset = metaNextOffset;
                    offset = metaNextOffset;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, {
                        members: members,
                        tasksByMemberAndDay: tasksByMemberAndDay,
                        days: days,
                        totalUsers: totalUsers,
                        nextOffset: nextOffset,
                        hasMoreUsers: hasMoreUsers || (typeof totalUsers === 'number' && nextOffset < totalUsers)
                    }];
            }
        });
    });
}
function fetchMonthForCurrentMemberWindow(options) {
    return __awaiter(this, void 0, Promise, function () {
        var companyId, month, startOffset, chunkSize, currentMembers, currentTasksByMemberAndDay, windowData, mergedDays, nextTasksByMemberAndDay, targetMemberIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    companyId = options.companyId, month = options.month, startOffset = options.startOffset, chunkSize = options.chunkSize, currentMembers = options.currentMembers, currentTasksByMemberAndDay = options.currentTasksByMemberAndDay;
                    return [4 /*yield*/, fetchMemberWindowWithCache({
                            companyId: companyId,
                            month: month,
                            startOffset: startOffset,
                            chunkSize: chunkSize
                        })];
                case 1:
                    windowData = _a.sent();
                    mergedDays = windowData.days;
                    nextTasksByMemberAndDay = shallowCloneTasksByMember(currentTasksByMemberAndDay);
                    targetMemberIds = new Set(currentMembers.map(function (member) { return member.id; }).filter(Boolean));
                    targetMemberIds.forEach(function (memberId) {
                        var currentRow = nextTasksByMemberAndDay[memberId] || {};
                        var windowRow = windowData.tasksByMemberAndDay[memberId] || {};
                        nextTasksByMemberAndDay[memberId] = __assign(__assign({}, currentRow), windowRow);
                        for (var _i = 0, mergedDays_1 = mergedDays; _i < mergedDays_1.length; _i++) {
                            var dateKey = mergedDays_1[_i];
                            if (!nextTasksByMemberAndDay[memberId][dateKey]) {
                                nextTasksByMemberAndDay[memberId][dateKey] = [];
                            }
                        }
                    });
                    return [2 /*return*/, {
                            mergedDays: mergedDays,
                            tasksByMemberAndDay: nextTasksByMemberAndDay
                        }];
            }
        });
    });
}
function fetchMemberWindowWithCache(options, preferCache) {
    if (preferCache === void 0) { preferCache = true; }
    var shouldBypassCache = Date.now() < bypassMemberWindowCacheUntil;
    var key = memberWindowCacheKey(options);
    if (!shouldBypassCache && preferCache && memberWindowCache.has(key)) {
        return Promise.resolve(memberWindowCache.get(key));
    }
    if (!shouldBypassCache && memberWindowInFlight.has(key)) {
        return memberWindowInFlight.get(key);
    }
    var requestGeneration = memberWindowCacheGeneration;
    var request = fetchValidMemberWindow(options).then(function (data) {
        if (requestGeneration === memberWindowCacheGeneration) {
            memberWindowCache.set(key, data);
        }
        memberWindowInFlight.delete(key);
        return data;
    });
    memberWindowInFlight.set(key, request);
    return request;
}
function prefetchMemberWindow(options) {
    if (Date.now() < bypassMemberWindowCacheUntil)
        return;
    if (options.startOffset < 0)
        return;
    var key = memberWindowCacheKey(options);
    if (memberWindowCache.has(key) || memberWindowInFlight.has(key))
        return;
    fetchMemberWindowWithCache(options, false).catch(function () {
        memberWindowInFlight.delete(key);
    });
}
function resolveRefreshMonths(params) {
    var loadedMonths = Array.from(new Set(params.dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
    if (!loadedMonths.length)
        return [];
    var baseMonths = params.visibleMonths && params.visibleMonths.length
        ? Array.from(new Set(params.visibleMonths))
        : loadedMonths;
    var expanded = new Set();
    for (var _i = 0, baseMonths_1 = baseMonths; _i < baseMonths_1.length; _i++) {
        var month = baseMonths_1[_i];
        var idx = loadedMonths.indexOf(month);
        if (idx < 0)
            continue;
        expanded.add(loadedMonths[idx]);
        if (idx - 1 >= 0)
            expanded.add(loadedMonths[idx - 1]);
        if (idx + 1 < loadedMonths.length)
            expanded.add(loadedMonths[idx + 1]);
    }
    return loadedMonths.filter(function (month) { return expanded.has(month); });
}
function getLoadedMonths(dayKeys) {
    return Array.from(new Set(dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
}
export var state = function () { return ({
    monthValue: dayjs().format('YYYY-MM'),
    dayKeys: [],
    loadedMembers: [],
    loadedMemberStartIndex: 0,
    tasksByMemberAndDay: {},
    hasMoreMembers: true,
    hasMoreMembersPrev: false,
    userOffset: 0,
    isLoading: false,
    totalUsers: null
}); };
export var getters = {
    monthValue: function (state) {
        return state.monthValue;
    },
    dayKeys: function (state) {
        return state.dayKeys;
    },
    loadedMembers: function (state) {
        return state.loadedMembers;
    },
    loadedMemberStartIndex: function (state) {
        return state.loadedMemberStartIndex;
    },
    tasksByMemberAndDay: function (state) {
        return state.tasksByMemberAndDay;
    },
    hasMoreMembers: function (state) {
        return state.hasMoreMembers;
    },
    hasMoreMembersPrev: function (state) {
        return state.hasMoreMembersPrev;
    },
    isLoading: function (state) {
        return state.isLoading;
    },
    totalUsers: function (state) {
        return state.totalUsers;
    }
};
export var mutations = (_a = {},
    _a[MemberAllocationMutationTypes.SET_MONTH_VALUE] = function (state, payload) {
        state.monthValue = payload;
    },
    _a[MemberAllocationMutationTypes.SET_DAY_KEYS] = function (state, payload) {
        state.dayKeys = payload;
    },
    _a[MemberAllocationMutationTypes.SET_LOADED_MEMBERS] = function (state, payload) {
        state.loadedMembers = payload;
    },
    _a[MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX] = function (state, payload) {
        state.loadedMemberStartIndex = payload;
    },
    _a[MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY] = function (state, payload) {
        state.tasksByMemberAndDay = payload;
    },
    _a[MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS] = function (state, payload) {
        state.hasMoreMembers = payload;
    },
    _a[MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV] = function (state, payload) {
        state.hasMoreMembersPrev = payload;
    },
    _a[MemberAllocationMutationTypes.SET_USER_OFFSET] = function (state, payload) {
        state.userOffset = payload;
    },
    _a[MemberAllocationMutationTypes.SET_IS_LOADING] = function (state, payload) {
        state.isLoading = payload;
    },
    _a[MemberAllocationMutationTypes.SET_TOTAL_USERS] = function (state, payload) {
        state.totalUsers = payload;
    },
    _a[MemberAllocationMutationTypes.UPDATE_MEMBER_LIST] = function (state, payload) {
        state.loadedMembers = payload;
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        resetMemberWindowCache();
        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, []);
        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, 0);
        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, {});
        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, true);
        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, false);
        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, 0);
        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, null);
        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, []);
    },
    initTimeline: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resetMemberWindowCache();
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, 0);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, 0);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, []);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, {});
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, true);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, false);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, null);
                        return [4 /*yield*/, dispatch('fetchTimeline', {
                                companyId: payload.companyId,
                                month: state.monthValue
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchTimeline: function (_a, payload) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var requestMonth, requestOffset, requestGeneration, isBackwardRequest, canLoadDirection, total, reachedTotal, windowData, days, currentMembers, currentTasks, metaTotal, nextOffset, effectiveTotal, nextLoadedEnd, hitTotal, hasMoreByMeta, hasMoreByOffset, hasMoreByChunkSize, hasMore, hasMorePrev, queuedOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestMonth = payload.month || state.monthValue;
                        requestOffset = state.userOffset;
                        requestGeneration = memberWindowCacheGeneration;
                        isBackwardRequest = requestOffset < state.loadedMemberStartIndex;
                        canLoadDirection = isBackwardRequest ? state.hasMoreMembersPrev : state.hasMoreMembers;
                        total = state.totalUsers;
                        reachedTotal = !isBackwardRequest && typeof total === 'number' && requestOffset >= total;
                        if (state.isLoading) {
                            queuedWindowOffset = requestOffset;
                            return [2 /*return*/];
                        }
                        if (!canLoadDirection || reachedTotal)
                            return [2 /*return*/];
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 7]);
                        return [4 /*yield*/, fetchMemberWindowWithCache({
                                companyId: payload.companyId,
                                month: requestMonth,
                                startOffset: requestOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK
                            })];
                    case 2:
                        windowData = _b.sent();
                        days = windowData.days;
                        // First chunk only: set columns. Vertical page 2+ keeps extended (multi-month) dayKeys.
                        if (state.loadedMembers.length === 0) {
                            commit(MemberAllocationMutationTypes.SET_DAY_KEYS, days);
                        }
                        currentMembers = windowData.members;
                        currentTasks = __assign(__assign({}, state.tasksByMemberAndDay), windowData.tasksByMemberAndDay);
                        if (requestGeneration !== memberWindowCacheGeneration) {
                            return [2 /*return*/];
                        }
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, currentTasks);
                        metaTotal = windowData.totalUsers;
                        if (metaTotal != null) {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, metaTotal);
                        }
                        nextOffset = windowData.nextOffset;
                        effectiveTotal = metaTotal !== null && metaTotal !== void 0 ? metaTotal : state.totalUsers;
                        nextLoadedEnd = requestOffset + currentMembers.length;
                        hitTotal = typeof effectiveTotal === 'number' && nextLoadedEnd >= effectiveTotal;
                        hasMoreByMeta = windowData.hasMoreUsers;
                        hasMoreByOffset = typeof effectiveTotal === 'number' ? nextOffset < effectiveTotal : false;
                        hasMoreByChunkSize = currentMembers.length >= MEMBER_SCROLL_CHUNK;
                        hasMore = !hitTotal && (hasMoreByMeta || hasMoreByOffset || hasMoreByChunkSize);
                        hasMorePrev = requestOffset > 0;
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, currentMembers);
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBER_START_INDEX, requestOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, hasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, hasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, nextOffset);
                        // Warm next/prev windows in background to reduce fling blank gaps.
                        prefetchMemberWindow({
                            companyId: payload.companyId,
                            month: requestMonth,
                            startOffset: requestOffset + MEMBER_SCROLL_STEP,
                            chunkSize: MEMBER_SCROLL_CHUNK
                        });
                        prefetchMemberWindow({
                            companyId: payload.companyId,
                            month: requestMonth,
                            startOffset: Math.max(0, requestOffset - MEMBER_SCROLL_STEP),
                            chunkSize: MEMBER_SCROLL_CHUNK
                        });
                        prefetchMemberWindow({
                            companyId: payload.companyId,
                            month: requestMonth,
                            startOffset: Math.max(0, requestOffset - MEMBER_SCROLL_STEP * 2),
                            chunkSize: MEMBER_SCROLL_CHUNK
                        });
                        return [3 /*break*/, 7];
                    case 3:
                        if (requestGeneration === memberWindowCacheGeneration) {
                            commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        }
                        queuedOffset = queuedWindowOffset;
                        if (!(requestGeneration === memberWindowCacheGeneration &&
                            queuedOffset != null &&
                            queuedOffset !== state.loadedMemberStartIndex &&
                            queuedOffset !== state.userOffset)) return [3 /*break*/, 5];
                        queuedWindowOffset = null;
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, queuedOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', { companyId: payload.companyId, month: requestMonth })];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        queuedWindowOffset = null;
                        _b.label = 6;
                    case 6: return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    refreshVisibleTimeline: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var savedOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, baseMembers, months, mergedTasks, _i, months_1, month, tasks;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading || !state.loadedMembers.length)
                            return [2 /*return*/];
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        baseMembers = __spreadArrays(state.loadedMembers);
                        months = Array.from(new Set(state.dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 6, 7]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        _i = 0, months_1 = months;
                        _b.label = 2;
                    case 2:
                        if (!(_i < months_1.length)) return [3 /*break*/, 5];
                        month = months_1[_i];
                        return [4 /*yield*/, fetchFullMonthForMerge(payload.companyId, month, baseMembers, mergedTasks)];
                    case 3:
                        tasks = (_b.sent()).tasks;
                        mergedTasks = tasks;
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        commit(MemberAllocationMutationTypes.SET_LOADED_MEMBERS, baseMembers);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        return [3 /*break*/, 7];
                    case 6:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    refreshVisibleTimelineByMember: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var memberIndex, globalMemberIndex, maxOffset, months, savedOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, nextTasksByMemberAndDay, _i, months_2, month, tasksByDay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading || !state.loadedMembers.length || !payload.userId)
                            return [2 /*return*/];
                        memberIndex = state.loadedMembers.findIndex(function (member) { return member.id === payload.userId; });
                        if (memberIndex < 0)
                            return [2 /*return*/];
                        globalMemberIndex = state.loadedMemberStartIndex + memberIndex;
                        maxOffset = Math.floor(globalMemberIndex / USER_LIMIT) * USER_LIMIT;
                        months = Array.from(new Set(state.dayKeys.map(function (dayKey) { return dayKey.slice(0, 7); })));
                        if (!months.length)
                            return [2 /*return*/];
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        nextTasksByMemberAndDay = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        if (!nextTasksByMemberAndDay[payload.userId]) {
                            nextTasksByMemberAndDay[payload.userId] = {};
                        }
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 6, 7]);
                        _i = 0, months_2 = months;
                        _b.label = 2;
                    case 2:
                        if (!(_i < months_2.length)) return [3 /*break*/, 5];
                        month = months_2[_i];
                        return [4 /*yield*/, fetchSingleUserTasksForMonth({
                                companyId: payload.companyId,
                                month: month,
                                userId: payload.userId,
                                maxOffset: maxOffset
                            })];
                    case 3:
                        tasksByDay = (_b.sent()).tasksByDay;
                        if (!tasksByDay)
                            return [3 /*break*/, 4];
                        nextTasksByMemberAndDay[payload.userId] = __assign(__assign({}, nextTasksByMemberAndDay[payload.userId]), tasksByDay);
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, nextTasksByMemberAndDay);
                        return [3 /*break*/, 7];
                    case 6:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    refreshCurrentMemberWindow: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var months, loadedMonths, currentOffset, currentHasMore, currentHasMorePrev, currentTotalUsers, mergedTasks, _i, months_3, month, tasksByMemberAndDay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading)
                            return [2 /*return*/];
                        if (!state.loadedMembers.length || !state.dayKeys.length)
                            return [2 /*return*/];
                        months = resolveRefreshMonths({
                            dayKeys: state.dayKeys,
                            visibleMonths: payload.months
                        });
                        if (!months.length)
                            return [2 /*return*/];
                        loadedMonths = getLoadedMonths(state.dayKeys);
                        currentOffset = state.loadedMemberStartIndex;
                        currentHasMore = state.hasMoreMembers;
                        currentHasMorePrev = state.hasMoreMembersPrev;
                        currentTotalUsers = state.totalUsers;
                        bypassMemberWindowCacheUntil = Date.now() + CACHE_BYPASS_MS_AFTER_MUTATION;
                        resetMemberWindowCache();
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 6, 7]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        _i = 0, months_3 = months;
                        _b.label = 2;
                    case 2:
                        if (!(_i < months_3.length)) return [3 /*break*/, 5];
                        month = months_3[_i];
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                month: month,
                                startOffset: currentOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: mergedTasks
                            })];
                    case 3:
                        tasksByMemberAndDay = (_b.sent()).tasksByMemberAndDay;
                        mergedTasks = tasksByMemberAndDay;
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        staleLoadedMonths.clear();
                        loadedMonths.forEach(function (month) {
                            if (!months.includes(month)) {
                                staleLoadedMonths.add(month);
                            }
                        });
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, currentOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, currentHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, currentHasMorePrev);
                        if (typeof currentTotalUsers === 'number') {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, currentTotalUsers);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    refreshDirtyVisibleMonths: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var targetMonths, currentOffset, savedHasMore, savedHasMorePrev, savedTotalUsers, mergedTasks, _i, targetMonths_1, month, tasksByMemberAndDay;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.isLoading)
                            return [2 /*return*/];
                        if (!state.loadedMembers.length || !state.dayKeys.length)
                            return [2 /*return*/];
                        if (!payload.months || payload.months.length === 0)
                            return [2 /*return*/];
                        targetMonths = payload.months.filter(function (month) { return staleLoadedMonths.has(month); });
                        if (!targetMonths.length)
                            return [2 /*return*/];
                        currentOffset = state.loadedMemberStartIndex;
                        savedHasMore = state.hasMoreMembers;
                        savedHasMorePrev = state.hasMoreMembersPrev;
                        savedTotalUsers = state.totalUsers;
                        bypassMemberWindowCacheUntil = Date.now() + 1000;
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 6, 7]);
                        mergedTasks = shallowCloneTasksByMember(state.tasksByMemberAndDay);
                        _i = 0, targetMonths_1 = targetMonths;
                        _b.label = 2;
                    case 2:
                        if (!(_i < targetMonths_1.length)) return [3 /*break*/, 5];
                        month = targetMonths_1[_i];
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                month: month,
                                startOffset: currentOffset,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: mergedTasks
                            })];
                    case 3:
                        tasksByMemberAndDay = (_b.sent()).tasksByMemberAndDay;
                        mergedTasks = tasksByMemberAndDay;
                        staleLoadedMonths.delete(month);
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, mergedTasks);
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, currentOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS_PREV, savedHasMorePrev);
                        if (typeof savedTotalUsers === 'number') {
                            commit(MemberAllocationMutationTypes.SET_TOTAL_USERS, savedTotalUsers);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    appendNextMonth: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var priorDayKeys, lastKey, month, savedOffset, savedHasMore, _b, mergedDays, tasksByMemberAndDay, existing_1, newDays, nextDayKeys;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!state.dayKeys.length || state.isLoading)
                            return [2 /*return*/];
                        priorDayKeys = __spreadArrays(state.dayKeys);
                        lastKey = priorDayKeys[priorDayKeys.length - 1];
                        month = dayjs(lastKey)
                            .add(1, 'month')
                            .format('YYYY-MM');
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                month: month,
                                startOffset: state.loadedMemberStartIndex,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: state.tasksByMemberAndDay
                            })];
                    case 2:
                        _b = _c.sent(), mergedDays = _b.mergedDays, tasksByMemberAndDay = _b.tasksByMemberAndDay;
                        if (!mergedDays.length)
                            return [2 /*return*/];
                        existing_1 = new Set(priorDayKeys);
                        newDays = mergedDays.filter(function (d) { return !existing_1.has(d); });
                        if (!newDays.length)
                            return [2 /*return*/];
                        nextDayKeys = __spreadArrays(priorDayKeys, newDays);
                        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, nextDayKeys);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, tasksByMemberAndDay);
                        return [3 /*break*/, 4];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    prependPrevMonth: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, Promise, function () {
            var priorDayKeys, firstKey, month, savedOffset, savedHasMore, _b, mergedDays, tasksByMemberAndDay, existing_2, newDays, nextDayKeys;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!state.dayKeys.length || state.isLoading)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        priorDayKeys = __spreadArrays(state.dayKeys);
                        firstKey = priorDayKeys[0];
                        month = dayjs(firstKey)
                            .subtract(1, 'month')
                            .format('YYYY-MM');
                        savedOffset = state.userOffset;
                        savedHasMore = state.hasMoreMembers;
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, fetchMonthForCurrentMemberWindow({
                                companyId: payload.companyId,
                                month: month,
                                startOffset: state.loadedMemberStartIndex,
                                chunkSize: MEMBER_SCROLL_CHUNK,
                                currentMembers: state.loadedMembers,
                                currentTasksByMemberAndDay: state.tasksByMemberAndDay
                            })];
                    case 2:
                        _b = _c.sent(), mergedDays = _b.mergedDays, tasksByMemberAndDay = _b.tasksByMemberAndDay;
                        if (!mergedDays.length)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        existing_2 = new Set(priorDayKeys);
                        newDays = mergedDays.filter(function (d) { return !existing_2.has(d); });
                        if (!newDays.length)
                            return [2 /*return*/, { prependedDayCount: 0 }];
                        nextDayKeys = __spreadArrays(newDays, priorDayKeys);
                        commit(MemberAllocationMutationTypes.SET_DAY_KEYS, nextDayKeys);
                        commit(MemberAllocationMutationTypes.SET_TASKS_BY_MEMBER_AND_DAY, tasksByMemberAndDay);
                        return [2 /*return*/, { prependedDayCount: newDays.length }];
                    case 3:
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, savedOffset);
                        commit(MemberAllocationMutationTypes.SET_HAS_MORE_MEMBERS, savedHasMore);
                        commit(MemberAllocationMutationTypes.SET_IS_LOADING, false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    updateMonth: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(MemberAllocationMutationTypes.SET_MONTH_VALUE, payload.monthValue);
                        return [4 /*yield*/, dispatch('initTimeline', { companyId: payload.companyId })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    appendMembers: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var anchorOffset, targetOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!state.hasMoreMembers)
                            return [2 /*return*/];
                        anchorOffset = typeof payload.anchorIndex === 'number'
                            ? payload.anchorIndex - Math.floor(MEMBER_SCROLL_CHUNK * 0.6)
                            : state.loadedMemberStartIndex + MEMBER_SCROLL_STEP;
                        targetOffset = normalizeWindowOffset({
                            requestedOffset: Math.max(state.loadedMemberStartIndex + MEMBER_SCROLL_STEP, anchorOffset),
                            totalUsers: state.totalUsers
                        });
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, targetOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', { companyId: payload.companyId, month: payload.month })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    prependMembers: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var anchorOffset, prevOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.loadedMemberStartIndex <= 0)
                            return [2 /*return*/];
                        anchorOffset = typeof payload.anchorIndex === 'number'
                            ? payload.anchorIndex - Math.floor(MEMBER_SCROLL_CHUNK * 0.2)
                            : state.loadedMemberStartIndex - MEMBER_SCROLL_STEP;
                        prevOffset = normalizeWindowOffset({
                            requestedOffset: Math.min(state.loadedMemberStartIndex - MEMBER_SCROLL_STEP, anchorOffset),
                            totalUsers: state.totalUsers
                        });
                        commit(MemberAllocationMutationTypes.SET_USER_OFFSET, prevOffset);
                        return [4 /*yield*/, dispatch('fetchTimeline', { companyId: payload.companyId, month: payload.month })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    reorderMember: function (_a, payload) {
        var commit = _a.commit, state = _a.state, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var companyId, userId, referenceUserId, place, current, sourceIndex, referenceIndex, moved, targetIndex, insertAt, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        companyId = payload.companyId, userId = payload.userId, referenceUserId = payload.referenceUserId, place = payload.place;
                        if (userId === referenceUserId)
                            return [2 /*return*/];
                        current = __spreadArrays(state.loadedMembers);
                        sourceIndex = current.findIndex(function (m) { return m.id === userId; });
                        referenceIndex = current.findIndex(function (m) { return m.id === referenceUserId; });
                        if (sourceIndex < 0 || referenceIndex < 0)
                            return [2 /*return*/];
                        moved = current.splice(sourceIndex, 1)[0];
                        targetIndex = current.findIndex(function (m) { return m.id === referenceUserId; });
                        if (targetIndex < 0)
                            return [2 /*return*/];
                        insertAt = place === 'before' ? targetIndex : targetIndex + 1;
                        current.splice(insertAt, 0, moved);
                        commit(MemberAllocationMutationTypes.UPDATE_MEMBER_LIST, current);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, MemberAllocationApiClient.updateUsersOrder(companyId, {
                                user_id: userId,
                                reference_user_id: referenceUserId,
                                place: place
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        // If API fails, we revert to original state by re-fetching
                        return [4 /*yield*/, dispatch('initTimeline', { companyId: companyId })];
                    case 4:
                        // If API fails, we revert to original state by re-fetching
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
};
var formatTimeProject = function (timeStr) {
    if (!timeStr || typeof timeStr !== 'string')
        return '';
    if (timeStr.match(/^\d{2}:\d{2}:\d{2}$/)) {
        return timeStr.slice(0, 5);
    }
    if (timeStr.match(/^\d{2}:\d{2}$/)) {
        return timeStr;
    }
    return '';
};
